@if (emailStats()) {
  <div class="border border-gray-200 rounded-lg p-6 bg-white">
    <div class="mb-6">
      <div class="field-label">
        Liczba użytkowników, do których zostanie wysłany komunikat
      </div>
      <div class="field-value">{{ emailStats()!.usersCount }}</div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <div class="field-label">Dzienny limit wiadomości mailowych</div>
        <div class="field-value">{{ emailStats()!.dailyLimit }}</div>
      </div>
      <div>
        <div class="field-label">Szacowany czas wysyłki wiadomości</div>
        <div class="field-value">{{ emailStats()!.estimatedTime }}</div>
      </div>
    </div>
  </div>

  <div class="flex justify-end mt-6 gap-4">
    <p-button
      styleClass="customInfoButton outlined"
      label="Anuluj"
      (click)="dialogRef.close()"
    ></p-button>
    <p-button
      styleClass="customDangerButton"
      label="Tak"
      (click)="dialogRef.close(true)"
    ></p-button>
  </div>
}
